import { render, staticRenderFns } from "./ChangesIndicator.vue?vue&type=template&id=3345abe2&"
import script from "./ChangesIndicator.vue?vue&type=script&lang=ts&"
export * from "./ChangesIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3345abe2')) {
      api.createRecord('3345abe2', component.options)
    } else {
      api.reload('3345abe2', component.options)
    }
    module.hot.accept("./ChangesIndicator.vue?vue&type=template&id=3345abe2&", function () {
      api.rerender('3345abe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/ChangesIndicator.vue"
export default component.exports